import { connect } from 'react-redux';
import Payments from './Payments';
import { fetchPayments } from '../../modules/Payment/actions';
import { billingAddressSelector, customPaymentMeanSelector } from '../../modules/Customer/selectors';
import { refreshPaymentDetailsOnDashboard } from '../../modules/Payment';
import { isLoadingSelector } from '../../modules/LoadingStatus';
import { paymentAuthenticationsSelector, paymentsSelector } from '../../modules/Payment/selector';
import { fetchPromoProductsRequest } from '../../modules/PromoProducts';

const filterPayment = payments =>
  payments.filter(
    payment =>
      !payment.paymentRequests?.[0] || payment.paymentRequests?.[0]?.bpmEventName !== 'paymentCreditWalletResultMsg'
  );

const mapStateToProps = state => ({
  hasUnauthenticatedPayment: !!paymentAuthenticationsSelector(state).length,
  hasBillingAddress: !!Object.keys(billingAddressSelector(state)).length,
  isRefreshingPaymentHistory: isLoadingSelector(state, 'refreshPaymentsHistory'),
  payments: filterPayment(paymentsSelector(state)),
  paymentMean: customPaymentMeanSelector(state),
  isRefreshingPaymentDetails: isLoadingSelector(state, 'refreshPaymentDetails'),
});

const mapDispatchToProps = {
  fetchPayments,
  fetchPromoProductsRequest,
  registerNewPayment: refreshPaymentDetailsOnDashboard,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payments);
